<template>
    <div id="map"></div>
</template>
<script>
export default {
    name: "MapBlock",
};
</script>
<style>
@import "~maplibre-gl/dist/maplibre-gl.css";

#map {
    height: 100%;
    display: flex;
}

.maplibregl-ctrl-attrib {
    color: #1298e0;
}

/* ZOOM CONTROLS */
.maplibregl-ctrl-group {
    background: #1298e0 !important;
}

.maplibregl-ctrl-zoom-in .maplibregl-ctrl-icon {
    background-image: url(data:image/svg+xml;charset=utf8,<svg%20viewBox%3D%270%200%2020%2020%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27>%0A%20%20<path%20style%3D%27fill%3A%23ffffff%3B%27%20d%3D%27M%2010%206%20C%209.446%206%209%206.4459904%209%207%20L%209%209%20L%207%209%20C%206.446%209%206%209.446%206%2010%20C%206%2010.554%206.446%2011%207%2011%20L%209%2011%20L%209%2013%20C%209%2013.55401%209.446%2014%2010%2014%20C%2010.554%2014%2011%2013.55401%2011%2013%20L%2011%2011%20L%2013%2011%20C%2013.554%2011%2014%2010.554%2014%2010%20C%2014%209.446%2013.554%209%2013%209%20L%2011%209%20L%2011%207%20C%2011%206.4459904%2010.554%206%2010%206%20z%27%20%2F>%0A<%2Fsvg>%0A) !important;
}

.maplibregl-ctrl-zoom-out .maplibregl-ctrl-icon {
    background-image: url(data:image/svg+xml;charset=utf8,<svg%20viewBox%3D%270%200%2020%2020%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27>%0A%20%20<path%20style%3D%27fill%3A%23ffffff%3B%27%20d%3D%27m%207%2C9%20c%20-0.554%2C0%20-1%2C0.446%20-1%2C1%200%2C0.554%200.446%2C1%201%2C1%20l%206%2C0%20c%200.554%2C0%201%2C-0.446%201%2C-1%200%2C-0.554%20-0.446%2C-1%20-1%2C-1%20z%27%20%2F>%0A<%2Fsvg>%0A) !important;
}

.maplibregl-ctrl-attrib-inner a {
    font-family: "Inter", sans-serif;
    font-size: 12px;
}

.maplibregl-ctrl-attrib-button {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 20 20%27 xmlns=%27http://www.w3.org/2000/svg%27 fill-rule=%27evenodd%27%3E%3Cpath fill=%27%231298E0%27 d=%27M4 10a6 6 0 1 0 12 0 6 6 0 1 0-12 0m5-3a1 1 0 1 0 2 0 1 1 0 1 0-2 0m0 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0%27/%3E%3C/svg%3E");
}

.maplibregl-ctrl-attrib.maplibregl-compact .maplibregl-ctrl-attrib-inner {
    font-size: 12px;
    line-height: 20px;
}

.maplibregl-ctrl > button:not(:disabled):hover {
    background-color: #06305e;
}

.maplibregl-ctrl > button:disabled {
    background-color: #fff;
}

/* Position controls */
.maplibregl-ctrl-top-right {
    top: 70px;
}

.maplibregl-ctrl-bottom-right {
    z-index: 10000;
}

.attribution-visible {
    bottom: 70px;
}

@media (max-width: 750px) {
    .maplibregl-ctrl-top-right .maplibregl-ctrl-group .maplibregl-ctrl-zoom-in,
    .maplibregl-ctrl-top-right
        .maplibregl-ctrl-group
        .maplibregl-ctrl-zoom-out {
        display: none;
    }
    .attribution-visible {
        bottom: calc(155px + 3vw);
    }
}

/* Fix issue on mobile browser where scroll breaks  */
.maplibregl-canvas-container.maplibregl-touch-zoom-rotate.maplibregl-touch-drag-pan,
.maplibregl-canvas-container.maplibregl-touch-zoom-rotate.maplibregl-touch-drag-pan
    .maplibregl-canvas {
    touch-action: unset;
}
</style>
